import View from './view';
import React from 'react';
import {CommonActions} from '@react-navigation/native';
import {IOwnProps} from './model';
import {Screens} from '../../../../../shared/routing';
import {getProfileRequests} from '../../../../../redux/actions/profile';

import {useAppDispatch} from '../../../../../redux';

export const CreateRequestMobile: React.FC<IOwnProps> = ({navigation}) => {
  const dispatch = useAppDispatch();
  return React.createElement(View, {
    onSuccessFormSubmit() {
      navigation.dispatch(
        CommonActions.reset({
          index: 1,
          routes: [{name: Screens.SupportService}, {name: Screens.SupportServiceTopics}],
        }),
      );
      dispatch(getProfileRequests());
    },
  });
};
